"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment CategoryBar on PageNavigation {\n    __typename\n    pageId\n    items {\n      __typename\n      itemId\n      label\n      url\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoryBar = void 0;
var _fetching = require("@ori/fetching");
const categoryBar = exports.categoryBar = (0, _fetching.gql)(_templateObject());
